import {
  addIncomeDetails,
  getIncomeDetails,
  updateIncomeDetails,
} from './digidiary.service';
import {getIncomeInformation, getUserIDState, handleAlert} from './sagaHelper';

import {
  DIGIDIARY_ADD_INCOME,
  DIGIDIARY_GET_EXPENSE,
  DIGIDIARY_GET_INCOME,
  DIGIDIARY_RESET_INCOME_TIMESTAMP,
  DIGIDIARY_SET_LOADER,
  POP_DIGIDIARY_VIEW,
  PUSH_DIGIDIARY_VIEW,
  TOTAL_INCOME_YIELD,
} from '../actions';

import {select, put, call, takeEvery} from 'redux-saga/effects';

export function* addIncomeData({data}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  let userId = yield select(getUserIDState);
  let response;
  if (!data.timeStamp) {
    let payload = {
      quantitySold: data.quantitySoldNum,
      amount: data.amountNum,
      rate: data.rateNum,
      incomeType: data.incomeType,
      entryType: data.entryType,
      description: data.description,
      cropId: data.cropId,
    };
    const incomeState = yield select(getIncomeInformation);

    response = yield addIncomeDetails(userId, payload);

    if (response?.statusCode && response.statusCode === 200) {
      if (response.data.incomeType === 'yield') {
        const dataObj = {
          ...incomeState,
          yieldTotalQtySold:
            incomeState?.yieldTotalQtySold + response.data.quantitySold,
          yieldTotal:
            incomeState?.yieldTotal +
            response.data.rate * response.data.quantitySold,
          yieldIncome: [...incomeState.yieldIncome, {...response.data}],
        };
        yield put({type: TOTAL_INCOME_YIELD, dataObj});
        let newView = 'yieldIncomeView';
        yield put({type: POP_DIGIDIARY_VIEW});
        yield put({type: PUSH_DIGIDIARY_VIEW, newView});
      } else {
        const dataObj = {
          ...incomeState,
          otherTotal: incomeState.otherTotal + response.data.amount,
          otherIncome: [...incomeState.otherIncome, {...response.data}],
        };
        yield put({type: TOTAL_INCOME_YIELD, dataObj});
        yield put({type: POP_DIGIDIARY_VIEW});
      }
      flag = false;
      yield put({type: DIGIDIARY_SET_LOADER, flag});
      yield put({type: DIGIDIARY_RESET_INCOME_TIMESTAMP});
      yield call(handleAlert, {variant: 'success', type: 'addIncomeSuccess'});
      yield put({type: DIGIDIARY_GET_EXPENSE});
    } else {
      flag = false;
      yield put({type: DIGIDIARY_SET_LOADER, flag});
      yield call(handleAlert, {variant: 'error', type: 'alertError'});
    }
  } else {
    let payload = {
      data: [
        {
          cropId: data.cropId,
          timestamp: data.timeStamp,
          quantitySold: data.quantitySoldNum,
          amount: data.amountNum,
          rate: data.rateNum,
          description: data.description,
          entryType: data.entryType,
          incomeType: data.incomeType,
        },
      ],
    };
    const incomeState = yield select(getIncomeInformation);
    response = yield updateIncomeDetails(userId, payload);

    if (response?.statusCode && response.statusCode === 200) {
      if (response.data[0] && response.data[0].incomeType === 'yield') {
        let updatedTotalYieldAmount =
          incomeState?.yieldTotal -
          incomeState?.yieldIncome[data.key].rate *
            incomeState?.yieldIncome[data.key].quantitySold +
          response.data[0].rate * response.data[0].quantitySold;

        let updatedYieldSoldQty =
          incomeState?.yieldTotalQtySold -
          incomeState?.yieldIncome[data.key].quantitySold +
          response.data[0].quantitySold;

        const newArray = [
          ...incomeState.yieldIncome.slice(0, data.key),
          response.data[0],
          ...incomeState.yieldIncome.slice(data.key + 1),
        ];

        const dataObj = {
          ...incomeState,
          yieldTotal: updatedTotalYieldAmount,
          yieldTotalQtySold: updatedYieldSoldQty,
          yieldIncome: newArray,
        };
        yield put({type: TOTAL_INCOME_YIELD, dataObj});
        yield put({type: DIGIDIARY_RESET_INCOME_TIMESTAMP});
        yield put({type: POP_DIGIDIARY_VIEW});
        yield call(handleAlert, {
          variant: 'success',
          type: 'updateIncomeSuccess',
        });
      } else {
        let updatedTotalOtherAmount =
          incomeState.otherTotal -
          incomeState.otherIncome[data.key].amount +
          response.data[0].amount;

        const newArray = [
          ...incomeState.otherIncome.slice(0, data.key),
          response.data[0],
          ...incomeState.otherIncome.slice(data.key + 1),
        ];
        const dataObj = {
          ...incomeState,
          otherTotal: updatedTotalOtherAmount,
          otherIncome: newArray,
        };
        yield put({type: TOTAL_INCOME_YIELD, dataObj});
        yield put({type: DIGIDIARY_RESET_INCOME_TIMESTAMP});
        yield put({type: POP_DIGIDIARY_VIEW});
        yield call(handleAlert, {
          variant: 'success',
          type: 'updateIncomeSuccess',
        });
      }
      flag = false;

      yield put({type: DIGIDIARY_SET_LOADER, flag});
      yield put({type: DIGIDIARY_GET_EXPENSE});
    } else {
      flag = false;
      yield put({type: DIGIDIARY_SET_LOADER, flag});
      yield call(handleAlert, {variant: 'error', type: 'alertError'});
    }
  }
}

export function* getIncomeData({data}) {
  let flag = true;
  yield put({type: DIGIDIARY_SET_LOADER, flag});
  let userId = yield select(getUserIDState);
  const response = yield getIncomeDetails(userId, data, 'income');
  flag = false;
  yield put({type: DIGIDIARY_SET_LOADER, flag});

  if (
    response.data.length != 0 &&
    response.statusCode &&
    response.statusCode === 200
  ) {
    if (response.data[0] && response.data[0].incomeType === 'yield') {
      const incomeState = yield select(getIncomeInformation);
      const yieldTotalQtySold = response.data[0].detail.reduce(
        (accumulator, currentObject) =>
          accumulator + currentObject.quantitySold,
        0
      );
      const dataObj = {
        ...incomeState,
        yieldTotalQtySold: yieldTotalQtySold,
        yieldTotal: response.data[0].total,
        yieldIncome: [...response.data[0].detail],
      };
      yield put({type: TOTAL_INCOME_YIELD, dataObj});
    } else if (response.data[1] && response.data[1].incomeType === 'yield') {
      const incomeState = yield select(getIncomeInformation);
      const yieldTotalQtySold = response.data[1].detail.reduce(
        (accumulator, currentObject) =>
          accumulator + currentObject.quantitySold,
        0
      );
      const dataObj = {
        ...incomeState,
        yieldTotalQtySold: yieldTotalQtySold,
        yieldTotal: response.data[1].total,
        yieldIncome: [...response.data[1].detail],
      };
      yield put({type: TOTAL_INCOME_YIELD, dataObj});
    }
    if (response.data[0] && response.data[0].incomeType === 'other') {
      const incomeState = yield select(getIncomeInformation);
      const dataObj = {
        ...incomeState,
        otherTotal: response.data[0].total,
        otherIncome: [...response.data[0].detail],
      };
      yield put({type: TOTAL_INCOME_YIELD, dataObj});
    } else if (response.data[1] && response.data[1].incomeType === 'other') {
      const incomeState = yield select(getIncomeInformation);
      const dataObj = {
        ...incomeState,
        otherTotal: response.data[1].total,
        otherIncome: [...response.data[1].detail],
      };
      yield put({type: TOTAL_INCOME_YIELD, dataObj});
    }
  }
}

export function* addIncomeSaga() {
  yield takeEvery(DIGIDIARY_ADD_INCOME, addIncomeData);
  yield takeEvery(DIGIDIARY_GET_INCOME, getIncomeData);
}
